import React from 'react'
import {
  Row,
  Typography,
  Col,
  SelectField,
  InputField,
  Divider,
  Button,
  Flex,
  Box,
  Gap,
  FabButton,
  Avatar,
} from "../../../ppui";
import { MdCurrencyRupee, MdDriveFolderUpload } from "react-icons/md";
import { BsFileEarmarkPdfFill } from "react-icons/bs";
import { SALARY_DETAILS_CONST } from "./pay-kyc-const";

const CreatePayKyc = ({
    paymentData,
    onChangePayment,
    OnBlurePayment,
    paymentErr,
    onSubmitPayKyc,
    onChangeKYCdoc,
    alldocs,
    kycDoc,
    fileInputRef,
    handleButtonClick,
    handleFileChange,
    DeleteSpecificFile,
    openFileInNewTab,
    checkDocName
}) => {
  return (
    <>
    <Typography variant="h5">Payment Structure</Typography>
    
    <Row rowGap>
      <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
        <SelectField
          defaultValue={paymentData?.salary_type}
          error={!!paymentErr?.salary_type}
          helperText={paymentErr?.salary_type}
          {...SALARY_DETAILS_CONST.salary_type}
          onChange={(e) => onChangePayment(e, "salary_type")}
          onBlur={(e) => OnBlurePayment(e, "salary_type")}
        />
      </Col>
      {
        paymentData?.salary_type === "fixed" && <>

          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <SelectField
              {...SALARY_DETAILS_CONST?.payment_mode}
              defaultValue={paymentData?.payment_mode}
              error={!!paymentErr?.payment_mode}
              helperText={paymentErr?.payment_mode}
              onChange={(e) => onChangePayment(e, "payment_mode")}
              onBlur={(e) => OnBlurePayment(e, "payment_mode")}
            />
          </Col>


          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <InputField
              {...SALARY_DETAILS_CONST?.ammount}
              error={!!paymentErr?.ammount}
              helperText={paymentErr?.ammount}
              value={paymentData?.ammount}
              valueSinc={!!paymentData?.ammount}
              onChange={(e) => onChangePayment(e, "ammount")}
              onBlur={(e) => OnBlurePayment(e, "ammount")}
              suffix={<MdCurrencyRupee />}
            />
          </Col>
          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <SelectField
            defaultValue={paymentData?.payment_by}
            error={!!paymentErr?.payment_by}
            helperText={paymentErr?.payment_by}
           
              onChange={(e) => onChangePayment(e, "payment_by")}
              onBlur={(e) => OnBlurePayment(e, "payment_by")}
              {...SALARY_DETAILS_CONST?.payment_by}
            />
          </Col>
        </>
      }
      {
        paymentData?.salary_type === "wages" && <>


          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <SelectField
              error={!!paymentErr?.wages_type}
              helperText={paymentErr?.wages_type}
              defaultValue={paymentData?.wages_type}
              onChange={(e) => onChangePayment(e, "wages_type")}
              onBlur={(e) => OnBlurePayment(e, "wages_type")}
              {...SALARY_DETAILS_CONST?.wages_type}
            />
          </Col>

          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <InputField
              error={!!paymentErr?.wages_rate}
              helperText={paymentErr?.wages_rate}
              value={paymentData?.wages_rate}
              onChange={(e) => onChangePayment(e, "wages_rate")}
              onBlur={(e) => OnBlurePayment(e, "wages_rate")}
              {...SALARY_DETAILS_CONST?.wages_rate}
            />
          </Col>
          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <SelectField
              error={!!paymentErr?.wages_payment_mode}
              helperText={paymentErr?.wages_payment_mode}
              defaultValue={paymentData?.wages_payment_mode}
              onChange={(e) => onChangePayment(e, "wages_payment_mode")}
              onBlur={(e) => OnBlurePayment(e, "wages_payment_mode")}
              {...SALARY_DETAILS_CONST?.wages_payment_mode}
            />
          </Col>

          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <InputField
              error={!!paymentErr?.wages_days}
              helperText={paymentErr?.wages_days}
              value={paymentData?.wages_days}
              onChange={(e) => onChangePayment(e, "wages_days")}
              onBlur={(e) => OnBlurePayment(e, "wages_days")}
              {...SALARY_DETAILS_CONST?.wages_days}
     
            />
          </Col>

          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <InputField
            error={!!paymentErr?.ammount}
            helperText={paymentErr?.ammount}
              value={paymentData?.ammount}
              valueSinc={!!paymentData?.ammount}
              onChange={(e) => onChangePayment(e, "ammount")}
              onBlur={(e) => OnBlurePayment(e, "ammount")}
              {...SALARY_DETAILS_CONST?.ammount}
              suffix={<MdCurrencyRupee />}
            />
          </Col>
          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <SelectField
            error={!!paymentErr?.payment_by}
            helperText={paymentErr?.payment_by}
            defaultValue={paymentData?.payment_by}
              onChange={(e) => onChangePayment(e, "payment_by")}
              onBlur={(e) => OnBlurePayment(e, "payment_by")}
              {...SALARY_DETAILS_CONST?.payment_by}
            />
          </Col>
        </>
      }





    </Row>
    <Divider gap={20} />

{
paymentData?.payment_by==="account_transfer" &&
<>
 <Typography variant="h5">Bank Details</Typography>

<Row rowGap>
<Col sm={12} md={4} lg={4} xxl={3}>
  <InputField
   error={!!paymentErr?.bank_name}
   helperText={paymentErr?.bank_name}
     value={paymentData?.bank_name}
     valueSinc={!!paymentData?.bank_name}
     onChange={(e) => onChangePayment(e, "bank_name")}
     onBlur={(e) => OnBlurePayment(e, "bank_name")}
    {...SALARY_DETAILS_CONST?.bank_name}
  />
</Col>
<Col sm={12} md={4} lg={4} xxl={3}>
  <InputField
    error={!!paymentErr?.branch_name}
    helperText={paymentErr?.branch_name}
      value={paymentData?.branch_name}
      valueSinc={!!paymentData?.branch_name}
      onChange={(e) => onChangePayment(e, "branch_name")}
      onBlur={(e) => OnBlurePayment(e, "branch_name")}
    {...SALARY_DETAILS_CONST?.branch_name}
  />
</Col>
<Col sm={12} md={4} lg={4} xxl={3}>
  <InputField
      error={!!paymentErr?.account_number}
      helperText={paymentErr?.account_number}
        value={paymentData?.account_number}
        valueSinc={!!paymentData?.account_number}
        onChange={(e) => onChangePayment(e, "account_number")}
        onBlur={(e) => OnBlurePayment(e, "account_number")}
    {...SALARY_DETAILS_CONST?.account_number}
  />
</Col>

<Col sm={12} md={4} lg={4} xxl={3}>
  <InputField
    error={!!paymentErr?.ifsc_code}
    helperText={paymentErr?.ifsc_code}
      value={paymentData?.ifsc_code}
      valueSinc={!!paymentData?.ifsc_code}
      onChange={(e) => onChangePayment(e, "ifsc_code")}
      onBlur={(e) => OnBlurePayment(e, "ifsc_code")}
    {...SALARY_DETAILS_CONST?.ifsc_code}
  />
</Col>
</Row>

<Divider gap={20} />

</>
}
   


    <Typography variant="h5">KYC Document</Typography>
    <Flex direction="column" gap={30}>
        {
                alldocs?.map((item, index) => (
                  <Row rowGap key={index}>
      
                    <Col sm={12} md={4} lg={8}>
                      <Flex gap={20}>
                        <Box>
                          <Avatar shape="square" icon={<BsFileEarmarkPdfFill />} />
                        </Box>
                        <Box>
                          <Typography variant="body2" mb={"0"} color={"dark"}>
                            {item?.document_type}
                          </Typography>
                          <Typography variant="h5" mb={"0"}>
                            {item?.document_number}
                          </Typography>
                        </Box>
                      </Flex>
                    </Col>
      
                    <Col sm={12} md={4} lg={4} xl={3} xxl={2}>
                      <Flex gap={10}>
                        <Button
                          onClick={() => DeleteSpecificFile(index)}
                          variant="filled"
                          size="sm"
                          color="danger"
                        >
                          Delete
                        </Button>
      
                        <Button
                          onClick={() => openFileInNewTab(item?.attachment)}
                          variant="filled"
                          size="sm"
                          color="primary"
                        >
                          View
                        </Button>
                      </Flex>
                    </Col>
                  </Row>
                ))
              }
   
       <Row rowGap>
                <Col sm={12} md={4} lg={4} xxl={3}>
                  <SelectField
                    defaultValue={kycDoc?.document_type}
                    options={[
                      { id: "AAdhar", name: "AAdhar",disabled: checkDocName("AAdhar") },
                      { id: "Pan", name: "Pan",disabled: checkDocName("Pan") },
                      { id: "Passport", name: "Passport",disabled: checkDocName("Passport") },
                    ]}
                    onChange={(e) => onChangeKYCdoc(e, "document_type")}
                    {...SALARY_DETAILS_CONST.document_type}
                  />
                </Col>
      
                <Col sm={12} md={4} lg={4} xxl={3}>
                  <InputField
                    value={kycDoc?.document_number ? kycDoc?.document_number : ""}
                    valueSinc={!!kycDoc?.document_number}
                    onChange={(e) => onChangeKYCdoc(e, "document_number")}
                    {...SALARY_DETAILS_CONST.document_number}
      
                  />
                </Col>
      
                <Col sm={12} md={4} lg={4} xl={3} xxl={2}>
                  <FabButton
                    icon={<MdDriveFolderUpload />}
                    onClick={handleButtonClick}
                    shape="extended"
                    variant="contained"
                  >
                    Upload
                  </FabButton>
      
      
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".png, .jpg, .jpeg, .doc, .docx, .pdf"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                  />
                </Col>
      
              </Row>
    </Flex>
    <Gap height={100} />
    <Flex justifyContent="flex-end" gap={"10"} mt={20}>
      <Button onClick={() => { }} variant="outlined">
        Cancel
      </Button>
      <Button color="primary" onClick={() => { onSubmitPayKyc()}} variant="outlined">
        Save & Exit
      </Button>
      <Button color="primary" onClick={() => { }} variant="contained">
        Next
      </Button>
    </Flex>
  </>
  )
}

export default CreatePayKyc